/**
 * helpUtils.js — tiny renderer + icon resolver shared by the Help page
 * and the OnboardingTour. Keeps the markup of a how-to card identical in
 * both surfaces.
 */
import React from 'react';
import {
  PenLine, BookOpen, Sparkles, Wallet, MessageCircle, Megaphone,
  Shield, AudioWaveform, HelpCircle,
} from 'lucide-react';

const ICONS = {
  PenLine, BookOpen, Sparkles, Wallet, MessageCircle, Megaphone,
  Shield, AudioWaveform,
};

export const IconFor = ({ name, className }) => {
  const C = ICONS[name] || HelpCircle;
  return <C className={className} />;
};

/**
 * Markdown-lite renderer. We only support **bold** + line breaks because
 * the source content is curated and we don't need a full md parser.
 * Returns a React fragment.
 */
export const renderInline = (line) => {
  if (!line) return null;
  const parts = line.split(/(\*\*[^*]+\*\*|`[^`]+`)/g);
  return parts.map((p, i) => {
    if (p.startsWith('**') && p.endsWith('**')) {
      return <strong key={i} className="font-bold text-white">{p.slice(2, -2)}</strong>;
    }
    if (p.startsWith('`') && p.endsWith('`')) {
      return <code key={i} className="px-1 py-0.5 rounded bg-slate-800 text-indigo-200 text-[11px] font-mono">{p.slice(1, -1)}</code>;
    }
    return <React.Fragment key={i}>{p}</React.Fragment>;
  });
};

export const audienceMeta = (aud) => {
  if (aud === 'writer') return { label: 'Scribes', c: 'bg-fuchsia-500/20 text-fuchsia-200 border-fuchsia-500/40' };
  if (aud === 'admin') return { label: 'Admins',  c: 'bg-amber-500/20 text-amber-200 border-amber-500/40' };
  return { label: 'Everyone', c: 'bg-slate-500/20 text-slate-200 border-slate-500/40' };
};
